import { render, staticRenderFns } from "./addToStorage.vue?vue&type=template&id=bc32a176&scoped=true&"
import script from "./addToStorage.vue?vue&type=script&lang=js&"
export * from "./addToStorage.vue?vue&type=script&lang=js&"
import style0 from "./addToStorage.vue?vue&type=style&index=0&id=bc32a176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc32a176",
  null
  
)

export default component.exports